import { render, staticRenderFns } from "./OrderPartseFile.vue?vue&type=template&id=6e2171a5&scoped=true"
import script from "./OrderPartseFile.vue?vue&type=script&lang=js"
export * from "./OrderPartseFile.vue?vue&type=script&lang=js"
import style0 from "./OrderPartseFile.vue?vue&type=style&index=0&id=6e2171a5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e2171a5",
  null
  
)

export default component.exports